import React from 'react';

const TabButtons = ({ btnRightLabel = 'Historial', btnLeftLabel = 'Pendientes', btnRightHandle, btnLeftHandle, btnDisabled }) => {
  return (
    <div className="row">
      <div className="btn-group col-3" role="group" style={{ borderRadius: 1 }}>
        <button
          type="button"
          onClick={btnLeftHandle}
          className={'btn btn-light'}
          style={{
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
            backgroundColor: btnDisabled ? '#FFEED9' : 'transparent',
            borderWidth: 1,
            borderColor: '#d4d4d4',
          }}
          disabled={btnDisabled}>
          {btnLeftLabel}
        </button>

        <button
          type="button"
          onClick={btnRightHandle}
          className={'btn btn-light'}
          style={{
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            backgroundColor: !btnDisabled ? '#FFEED9' : 'transparent',
            borderWidth: 1,
            borderColor: '#d4d4d4',
          }}
          disabled={!btnDisabled}>
          {btnRightLabel}
        </button>
      </div>
    </div>
  );
};

export default TabButtons;
